module.exports = __webpack_public_path__ + "img/ningling.1e49c36e.png";